import React__default from 'react';
import { C as CHARCOAL_100 } from '../../../../color-palette-0a32e1d4.js';

var MenuIcon = function MenuIcon() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M2.75 3C2.33579 3 2 3.33579 2 3.75C2 4.16421 2.33579 4.5 2.75 4.5H17.25C17.6642 4.5 18 4.16421 18 3.75C18 3.33579 17.6642 3 17.25 3H2.75Z",
    fill: CHARCOAL_100
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2 10C2 9.58579 2.33579 9.25 2.75 9.25H17.25C17.6642 9.25 18 9.58579 18 10C18 10.4142 17.6642 10.75 17.25 10.75H2.75C2.33579 10.75 2 10.4142 2 10Z",
    fill: CHARCOAL_100
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2 16.25C2 15.8358 2.33579 15.5 2.75 15.5H17.25C17.6642 15.5 18 15.8358 18 16.25C18 16.6642 17.6642 17 17.25 17H2.75C2.33579 17 2 16.6642 2 16.25Z",
    fill: CHARCOAL_100
  }));
};

export { MenuIcon };
//# sourceMappingURL=index.mjs.map
